import React from "react";
import cn from "classnames";
import Input from "../Input";
import classNames from "classnames";
import { Icon } from "../Icon/Icon";
const Search = React.forwardRef(({ className, dataCySuffix, ...rest }, ref) => {
    const dataCy = (name) => {
        return dataCySuffix ? `${name}-${dataCySuffix}` : name;
    };
    const dataCyProps = {
        root: dataCy("ukt-search"),
        input: dataCy("ukt-search-input"),
    };
    return (React.createElement("div", { className: cn("ukt-search relative w-full shadow-big", className), "data-cy": dataCyProps.root },
        React.createElement(Icon, { className: classNames("icon search-icon absolute top-3 left-3 z-[1]", rest.small ? "icon-md top-1.5" : "top-3") }),
        React.createElement(Input, { ref: ref, ...rest, className: rest.small ? "pl-9" : "pl-11", "data-cy": dataCyProps.input })));
});
export default Search;
//# sourceMappingURL=Search.js.map